import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import CabinetShell from '../orders/CabinetShell';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Download, FileText, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { fmtDate } from '../orders/orderConstants';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CabinetInvoices() {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAll = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/client-invoices`);
      setInvoices(data);
    } catch (e) {
      toast.error('Erreur de chargement des factures');
    } finally { setLoading(false); }
  }, []);
  useEffect(() => { fetchAll(); }, [fetchAll]);

  return (
    <CabinetShell title="Mes factures">
      {loading ? (
        <div className="flex justify-center py-12"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>
      ) : invoices.length === 0 ? (
        <Card className="border-dashed"><CardContent className="py-12 text-center text-muted-foreground">
          <FileText className="h-10 w-10 mx-auto mb-3 opacity-40" />
          <p>Aucune facture disponible.</p>
        </CardContent></Card>
      ) : (
        <div className="space-y-2" data-testid="cabinet-invoices-list">
          {invoices.map((inv) => (
            <Card key={inv.id} className="border-border" data-testid={`cabinet-inv-row-${inv.invoice_number}`}>
              <CardContent className="py-3 flex items-center justify-between gap-3 flex-wrap">
                <div>
                  <p className="font-semibold text-sm">{inv.invoice_number}</p>
                  <p className="text-xs text-muted-foreground">
                    {inv.lines.length} ligne(s) · {fmtDate(inv.created_at)} · TTC <b>{inv.total.toFixed(2)} €</b>
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <Badge variant="outline" className={inv.status === 'sent' ? 'bg-green-50 text-green-700 border-green-200' : 'bg-emerald-50 text-emerald-700 border-emerald-200'}>
                    {inv.status === 'sent' ? 'Envoyée' : 'Disponible'}
                  </Badge>
                  <a href={`${API}/client-invoices/${inv.id}/pdf`} target="_blank" rel="noreferrer">
                    <Button size="sm" variant="outline" className="gap-1" data-testid={`cabinet-inv-pdf-${inv.invoice_number}`}>
                      <Download className="h-4 w-4" />PDF
                    </Button>
                  </a>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </CabinetShell>
  );
}
